import { ReactNode } from 'react';
import { CopyButton } from 'components/copy-button';
import {
    AddressReadable,
    copyAddress,
} from 'components/pages/campaign-settings/campaign-auction/AddressReadable';
import { Address } from 'types/domain';

interface CopyContactInfoProps {
    email?: string | null;
    phone?: string | null;
    address?: Address | null;
    className?: string;
}

const CopyContactInfo = (props: CopyContactInfoProps) => {
    const { email, phone, address, className = '' } = props;
    return (
        <div className={className} id={'copy-contact-info'}>
            <div className={'flex flex-col gap-y-2'}>
                <p
                    className={
                        'text-xs font-normal text-gray-500 sm:text-sm sm:font-medium sm:text-black'
                    }
                >
                    Contact
                </p>
                {!!email && (
                    <CopyData dataToCopyString={email}>
                        <p className={'text-sm'}>{email}</p>
                    </CopyData>
                )}
                {!!phone && (
                    <CopyData dataToCopyString={phone}>
                        <p className={'text-sm'}>{phone}</p>
                    </CopyData>
                )}
            </div>
            {address && (
                <div className={'flex flex-col gap-y-2'}>
                    <p
                        className={
                            'text-xs font-normal text-gray-500 sm:text-sm sm:font-medium sm:text-black'
                        }
                    >
                        Shipping Address
                    </p>
                    <CopyData dataToCopyString={copyAddress(address)}>
                        <AddressReadable address={address} />
                    </CopyData>
                </div>
            )}
        </div>
    );
};

interface CopyDataProps {
    children: ReactNode;
    dataToCopyString: string;
    className?: string;
}

const CopyData = (props: CopyDataProps) => {
    return (
        <div
            className={`flex items-center justify-between rounded bg-gray-100 px-2.5 py-1 ${props.className}`}
        >
            {props.children}
            <CopyButton text={props.dataToCopyString} />
        </div>
    );
};

export { CopyContactInfo };
export type { CopyContactInfoProps };
